import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import firebase from 'firebase/compat/app';

const firebaseConfig = {
    apiKey: "AIzaSyASEidm-o-6HN9O9MtmFeveJhW-bm9tR4c",
    authDomain: "birthday-app-48b8c.firebaseapp.com",
    databaseURL: "https://birthday-app-48b8c.firebaseio.com",
    projectId: "birthday-app-48b8c",
    storageBucket: "birthday-app-48b8c.appspot.com",
    messagingSenderId: "989259836209",
    appId: "1:989259836209:web:a7a8bfe3b939389e69de10"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// export database
export { db, firebase };

// databaseURL: "https://birthday-app-48b8c.firebaseio.com",